module.exports = __webpack_public_path__ + "static/micrositios-c69e337e853b5a1dde05aa5fe23352c4.png";